import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useContentsGet() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, refetch } = useQuery(
    ["contents"],
    () =>
      makeAuthedRequest(`contents`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
